export const beforeLoginPaths: Array<string> = [
  '/',
  '/signIn',
  '/password',
  '/signUp',
  '/tabFaq'
]
